import { render, staticRenderFns } from "./expand-icon.vue?vue&type=template&id=54711439&scoped=true&"
import script from "./expand-icon.vue?vue&type=script&lang=js&"
export * from "./expand-icon.vue?vue&type=script&lang=js&"
import style0 from "./expand-icon.vue?vue&type=style&index=0&id=54711439&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54711439",
  null
  
)

export default component.exports